import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backToTop"]

  connect() {
    this.toggleButton()
    this.scrollHandler = () => this.toggleButton()
    window.addEventListener("scroll", this.scrollHandler)
  }

  disconnect() {
    window.removeEventListener("scroll", this.scrollHandler)
  }

  toggleButton() {
    const shouldShow = window.scrollY > 200
    this.backToTopTarget.classList.toggle("opacity-100", shouldShow)
    this.backToTopTarget.classList.toggle("pointer-events-auto", shouldShow)
    this.backToTopTarget.classList.toggle("opacity-0", !shouldShow)
    this.backToTopTarget.classList.toggle("pointer-events-none", !shouldShow)
  }

  scrollToTopAndAnimateShadow() {
    const button = this.backToTopTarget

    button.classList.remove("back-to-top-shadow")
    button.classList.add("back-to-top-shadow-active")

    window.scrollTo({ top: 0, behavior: 'smooth' })

    setTimeout(() => {
      button.classList.remove("back-to-top-shadow-active")
      button.classList.add("back-to-top-shadow")
    }, 300)
  }
}
